import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-3 overflow-hidden rounded-full bg-slate-200/70"
}
const _hoisted_2 = { class: "flex items-center justify-between mb-5" }
const _hoisted_3 = { class: "space-y-6" }
const _hoisted_4 = { class: "opacity-60" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "flex items-center gap-3 rounded-2xl border border-white/70 bg-slate-50/90 p-3 shadow-inner" }
const _hoisted_8 = ["value"]
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-5" }
const _hoisted_11 = { class: "inline-flex items-center gap-2" }
const _hoisted_12 = { class: "truncate" }
const _hoisted_13 = {
  key: 0,
  class: "opacity-60"
}
const _hoisted_14 = {
  key: 0,
  class: "truncate"
}
const _hoisted_15 = {
  key: 1,
  class: "truncate"
}
const _hoisted_16 = { class: "inline-flex items-center gap-2" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "truncate" }
const _hoisted_19 = { class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-sky-600 shadow-sm" }
const _hoisted_20 = { class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white text-slate-500 shadow-sm" }
const _hoisted_21 = {
  key: 0,
  class: "mt-2 flex flex-col items-center justify-center gap-2 sm:flex-row"
}
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_DropDown = _resolveComponent("DropDown")!

  return (_openBlock(), _createElementBlock("div", {
    class: "relative rounded-[2rem] border border-white/75 bg-white/78 p-3 text-slate-700 shadow-[0_24px_70px_rgba(148,163,184,0.32)] ring-1 ring-slate-200/70 backdrop-blur-xl",
    onClick: _cache[16] || (_cache[16] = _withModifiers(() => {}, ["stop"]))
  }, [
    (_ctx.downloading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "h-2 rounded-full bg-gradient-to-r from-sky-400 via-blue-400 to-cyan-300 transition-all duration-300",
            style: _normalizeStyle({ width: `${_ctx.progress}%` })
          }, null, 4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.advancedOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "absolute bottom-[calc(100%+0.75rem)] left-0 right-0 z-30 max-h-[60vh] overflow-y-auto rounded-[2rem] border border-white/75 bg-white/95 p-5 pb-20 text-slate-700 shadow-[0_20px_60px_rgba(15,23,42,0.18)] ring-1 ring-slate-200/70 backdrop-blur-2xl sm:left-auto sm:right-0 sm:w-[320px]",
              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-xs font-black uppercase tracking-[0.25em] text-slate-400" }, "Advanced Settings", -1)),
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.advancedOpen = false)),
                  class: "flex h-6 w-6 items-center justify-center rounded-full bg-slate-100 text-slate-400 hover:bg-slate-200 hover:text-slate-600"
                }, [
                  _createVNode(_component_ion_icon, { name: "close-outline" })
                ])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", null, [
                  _cache[18] || (_cache[18] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Grid Size", -1)),
                  _createVNode(_component_DropDown, {
                    direction: "down",
                    options: ['2', '3', '4', '5'],
                    disabled: _ctx.downloading,
                    onClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateSize(parseInt($event))))
                  }, {
                    selected: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.size) + "x" + _toDisplayString(_ctx.size) + " Grid", 1)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.option) + "x" + _toDisplayString(slotProps.option), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", null, [
                  _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Upscale Model", -1)),
                  _createVNode(_component_DropDown, {
                    direction: "down",
                    options: ['Swin2SR', '6B', 'HFA2kShallowESRGAN'],
                    disabled: _ctx.downloading,
                    onClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updateModel($event)))
                  }, {
                    selected: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.upscaleModel === '6B' ? 'High Quality' : (_ctx.upscaleModel === 'HFA2kShallowESRGAN' ? 'Fast' : 'Balanced')), 1)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.option === '6B' ? 'High Quality' : (slotProps.option === 'HFA2kShallowESRGAN' ? 'Fast' : 'Balanced')) + " ", 1),
                      _createElementVNode("small", _hoisted_4, _toDisplayString(slotProps.option === '6B' ? '(Real-ESRGAN)' : (slotProps.option === 'HFA2kShallowESRGAN' ? '(HFA2k)' : '(Swin2SR)')), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", null, [
                  _cache[20] || (_cache[20] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Worker Pool Size", -1)),
                  _createVNode(_component_DropDown, {
                    direction: "down",
                    options: ['1', '3', '6', '9'],
                    disabled: _ctx.downloading,
                    onClicked: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateWorkers($event)))
                  }, {
                    selected: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(_ctx.workerCount) + " Workers", 1)
                    ]),
                    option: _withCtx((slotProps) => [
                      _createTextVNode(_toDisplayString(slotProps.option) + " Workers ", 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _createElementVNode("div", null, [
                  _cache[22] || (_cache[22] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Image Processing", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateForceUpscale(!_ctx.forceUpscale))),
                    disabled: _ctx.downloading,
                    class: "flex min-h-11 w-full items-center justify-between gap-3 rounded-2xl border border-white/70 bg-slate-50/90 px-4 py-3 text-left text-sm font-medium text-slate-700 shadow-inner hover:bg-white/90 disabled:opacity-50"
                  }, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "Force Upscale", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["relative h-6 w-11 rounded-full transition-colors duration-200 ease-in-out", _ctx.forceUpscale ? 'bg-sky-400' : 'bg-slate-300'])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out", _ctx.forceUpscale ? 'translate-x-5' : 'translate-x-0'])
                      }, null, 2)
                    ], 2)
                  ], 8, _hoisted_5)
                ]),
                _createElementVNode("div", null, [
                  _cache[24] || (_cache[24] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Title Overlay", -1)),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.updateIncludeTitles(!_ctx.includeTitles))),
                    disabled: _ctx.downloading,
                    class: "flex min-h-11 w-full items-center justify-between gap-3 rounded-2xl border border-white/70 bg-slate-50/90 px-4 py-3 text-left text-sm font-medium text-slate-700 shadow-inner hover:bg-white/90 disabled:opacity-50"
                  }, [
                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "Include Titles", -1)),
                    _createElementVNode("div", {
                      class: _normalizeClass(["relative h-6 w-11 rounded-full transition-colors duration-200 ease-in-out", _ctx.includeTitles ? 'bg-sky-400' : 'bg-slate-300'])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform duration-200 ease-in-out", _ctx.includeTitles ? 'translate-x-5' : 'translate-x-0'])
                      }, null, 2)
                    ], 2)
                  ], 8, _hoisted_6)
                ]),
                _createElementVNode("div", null, [
                  _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-slate-400" }, "Border Appearance", -1)),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("input", {
                      class: "h-11 w-14 cursor-pointer rounded-xl border border-slate-200 bg-transparent p-1",
                      type: "color",
                      id: "color",
                      value: _ctx.color,
                      onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.updateColor($event)))
                    }, null, 40, _hoisted_8),
                    _createElementVNode("input", {
                      class: "w-full accent-sky-400",
                      type: "range",
                      value: _ctx.alpha,
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateAlpha($event)))
                    }, null, 40, _hoisted_9)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_DropDown, {
        options: _ctx.projectOptions,
        disabled: _ctx.downloading,
        onClicked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.handleProjectAction($event)))
      }, {
        selected: _withCtx(() => [...(_cache[26] || (_cache[26] = [
          _createElementVNode("span", { class: "truncate" }, "Project", -1)
        ]))]),
        option: _withCtx((slotProps) => [
          _createElementVNode("span", _hoisted_11, [
            _createVNode(_component_ion_icon, {
              name: slotProps.option === 'import' ? 'folder-open-outline' : 'save-outline'
            }, null, 8, ["name"]),
            _createElementVNode("span", null, _toDisplayString(slotProps.option === 'import' ? 'Import' : 'Export'), 1)
          ])
        ]),
        _: 1
      }, 8, ["options", "disabled"]),
      _createVNode(_component_DropDown, {
        options: ['200', '400'],
        disabled: _ctx.downloading,
        onClicked: _cache[10] || (_cache[10] = ($event: any) => (_ctx.cellSize = parseInt($event)))
      }, {
        selected: _withCtx(() => [
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.size) + "x" + _toDisplayString(_ctx.size) + " (" + _toDisplayString(_ctx.size*_ctx.cellSize) + "px)", 1)
        ]),
        option: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(_ctx.size) + "x" + _toDisplayString(_ctx.size) + " (" + _toDisplayString(_ctx.size*parseInt(slotProps.option)) + "px) ", 1),
          (slotProps.option === '400')
            ? (_openBlock(), _createElementBlock("small", _hoisted_13, "(upscale)"))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_DropDown, {
        options: _ctx.downloadFormats,
        onClicked: _cache[11] || (_cache[11] = ($event: any) => (_ctx.download($event)))
      }, {
        selected: _withCtx(() => [
          (_ctx.downloading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Processing..."))
            : (_openBlock(), _createElementBlock("span", _hoisted_15, "Download"))
        ]),
        option: _withCtx((slotProps) => [
          _createElementVNode("span", _hoisted_16, [
            _createVNode(_component_ion_icon, { name: "download-outline" }),
            _createElementVNode("span", null, _toDisplayString(_ctx.formatMimeLabel(slotProps.option)), 1)
          ])
        ]),
        _: 1
      }, 8, ["options"]),
      _createElementVNode("button", {
        type: "button",
        disabled: _ctx.downloading || _ctx.sharing,
        class: "flex min-h-11 w-full items-center justify-between gap-3 rounded-2xl border border-sky-200/80 bg-sky-50/90 px-4 py-3 text-left text-sm font-medium text-sky-700 shadow-sm hover:bg-white disabled:cursor-not-allowed disabled:opacity-50",
        onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.share && _ctx.share(...args)), ["stop"]))
      }, [
        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.sharing ? 'Uploading...' : 'Share'), 1),
        _createElementVNode("span", _hoisted_19, [
          _createVNode(_component_ion_icon, {
            name: _ctx.sharing ? 'cloud-upload-outline' : 'share-social-outline'
          }, null, 8, ["name"])
        ])
      ], 8, _hoisted_17),
      _createElementVNode("button", {
        type: "button",
        class: "flex min-h-11 w-full items-center justify-between gap-3 rounded-2xl border border-white/70 bg-slate-100/75 px-4 py-3 text-left text-sm font-medium text-slate-700 shadow-sm hover:bg-white/90",
        onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.advancedOpen = !_ctx.advancedOpen), ["stop"]))
      }, [
        _cache[27] || (_cache[27] = _createElementVNode("span", { class: "truncate" }, "Advanced", -1)),
        _createElementVNode("span", _hoisted_20, [
          _createVNode(_component_ion_icon, {
            name: _ctx.advancedOpen ? 'chevron-up-outline' : 'chevron-down-outline'
          }, null, 8, ["name"])
        ])
      ])
    ]),
    (_ctx.shareMessage)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["mt-3 rounded-xl px-3 py-2 text-center text-xs font-medium", _ctx.shareError ? 'bg-red-50 text-red-700' : 'bg-emerald-50 text-emerald-700']),
          role: "status"
        }, [
          _createElementVNode("p", null, _toDisplayString(_ctx.shareMessage), 1),
          (_ctx.shareUrl)
            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                _createElementVNode("a", {
                  href: _ctx.shareUrl,
                  class: "max-w-full truncate underline underline-offset-2",
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, _toDisplayString(_ctx.shareUrl), 9, _hoisted_22),
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["inline-flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-1.5 font-semibold shadow-sm", _ctx.copyFeedback === 'copied'
            ? 'bg-emerald-600 text-white'
            : _ctx.copyFeedback === 'failed'
              ? 'bg-red-600 text-white'
              : 'bg-white text-slate-700 hover:bg-slate-50']),
                  onClick: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyUploadedUrl && _ctx.copyUploadedUrl(...args)), ["stop"])),
                  "aria-live": "polite"
                }, [
                  _createVNode(_component_ion_icon, {
                    name: _ctx.copyFeedback === 'copied' ? 'checkmark-outline' : _ctx.copyFeedback === 'failed' ? 'close-outline' : 'copy-outline'
                  }, null, 8, ["name"]),
                  _createTextVNode(" " + _toDisplayString(_ctx.copyFeedback === 'copied' ? 'Copied!' : _ctx.copyFeedback === 'failed' ? 'Copy failed' : 'Copy link'), 1)
                ], 2)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("input", {
      ref: "projectInput",
      class: "hidden",
      type: "file",
      accept: ".json,.3x3.json,application/json",
      onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleProjectFile && _ctx.handleProjectFile(...args)))
    }, null, 544)
  ]))
}